import { render, staticRenderFns } from "./recharge-wallet.vue?vue&type=template&id=25e3b53f&scoped=true"
import script from "./recharge-wallet.vue?vue&type=script&lang=js"
export * from "./recharge-wallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3b53f",
  null
  
)

export default component.exports